/**
 * 検索の選択のデフォルト
 */
export const SEARCH_EMPTY_SELECT = '指定なし';

/**
 * 発生事象 0:その他
 */
export const IssueTypeOther = { value: 0, label: 'その他' };

/**
 * keyとvalueをもつ汎用的な型
 */
type KeyValuePair<T> = {
  key: T,
  value: string,
};

/**
 * valueとlabelをもつ汎用的な型
 */
type ValueLabelPair<T> = {
  value: T,
  label: string,
};

/**
 * keyとvalueをもつ汎用的な型
 */
type Section = {
  key: SectionKeys,
  value: string,
};

/**
 * 競合ステータス
 * 0: なし
 * 1: 競合あり
 */
export enum ConflictStatus {
  NONE = 0,
  CONFLICT = 1,
}

/**
 * ロールのキー名
 */
export enum RoleKeys {
  worker_read = 'worker:read',
  worker_write = 'worker:write',
  manager = 'manager',
  generalmanager = 'generalmanager',
  administrator = 'administrator',
  none = 'none',
}

/**
 * ロール
 */
export const Roles: KeyValuePair<RoleKeys>[] = [
  { key: RoleKeys.worker_read, value: '業務実施会社(閲覧のみ)' },
  { key: RoleKeys.worker_write, value: '業務実施会社(更新可)' },
  { key: RoleKeys.manager, value: '業務実施責任会社' },
  { key: RoleKeys.generalmanager, value: '統括管理者' },
  { key: RoleKeys.administrator, value: 'システム管理者' },
  { key: RoleKeys.none, value: 'なし' },
];

/**
 * ロール(Z権限の権限一覧)
 */
export const Roles_Z: KeyValuePair<RoleKeys>[] = [
  { key: RoleKeys.worker_read, value: '業務実施会社(閲覧のみ)' },
  { key: RoleKeys.worker_write, value: '業務実施会社(更新可)' },
  { key: RoleKeys.manager, value: '業務実施責任会社' },
  { key: RoleKeys.generalmanager, value: '統括管理者' },
  { key: RoleKeys.administrator, value: 'システム管理者' },
];
/**
 * ロール(A権限の権限一覧)
 */
export const Roles_A: KeyValuePair<RoleKeys>[] = [
  { key: RoleKeys.generalmanager, value: '統括管理者' },
];
/**
 * ロール(B権限の権限一覧)
 */
export const Roles_B: KeyValuePair<RoleKeys>[] = [
  { key: RoleKeys.worker_read, value: '業務実施会社(閲覧のみ)' },
  { key: RoleKeys.worker_write, value: '業務実施会社(更新可)' },
  { key: RoleKeys.manager, value: '業務実施責任会社' },
];

/**
 * 業務種別コードのキー名
 */
export enum BusinessTypeKeys {
  cleaning = 'cleaning',
  security = 'security',
  equipment = 'equipment',
  greening = 'greening',
  bispot = 'bispot',
  all = 'all',
  none = 'none',
}

/**
 * 業務種別コード
 */
export const BusinessTypes: KeyValuePair<BusinessTypeKeys>[] = [
  { key: BusinessTypeKeys.cleaning, value: '清掃' },
  { key: BusinessTypeKeys.security, value: '警備' },
  { key: BusinessTypeKeys.equipment, value: '設備' },
  { key: BusinessTypeKeys.greening, value: '植栽' },
  { key: BusinessTypeKeys.bispot, value: 'Bispot' },
  { key: BusinessTypeKeys.all, value: 'すべて' },
];

/**
 * 臨時作業入力画面用の業務種別コード
 */
export const IssueBusinessTypes: KeyValuePair<BusinessTypeKeys>[] = [
  { key: BusinessTypeKeys.cleaning, value: '清掃' },
  { key: BusinessTypeKeys.security, value: '警備' },
  { key: BusinessTypeKeys.equipment, value: '設備' },
  { key: BusinessTypeKeys.greening, value: '植栽' },
];

/**
 * 作業一括登録画面用の業務種別コード
 */
export const CsvBusinessTypes: KeyValuePair<BusinessTypeKeys>[] = [
  { key: BusinessTypeKeys.cleaning, value: '清掃' },
  { key: BusinessTypeKeys.greening, value: '植栽' },
];

/**
 * 表示用の検索区分コードのキー名
 */
export enum SectionDisplayKeys {
  key = 'key',
  fire = 'fire',
  ext = 'ext',
}

/**
 * 表示用の検索区分コード
 */
export const SectionDisplay: KeyValuePair<SectionDisplayKeys>[] = [
  { key: SectionDisplayKeys.key, value: '鍵' },
  { key: SectionDisplayKeys.fire, value: '火気' },
  { key: SectionDisplayKeys.ext, value: '特殊' },
];

/**
 * 作業区分コードのキー名
 */
export enum SectionKeys {
  key = 'key',
  fire = 'fire',
  ext = 'ext',
  bispot = 'bispot',
}

/**
 * 作業区分コード
 */
export const Sections: Section[] = [
  { key: SectionKeys.key, value: '鍵' },
  { key: SectionKeys.fire, value: '火気' },
  { key: SectionKeys.ext, value: '特殊' },
  { key: SectionKeys.bispot, value: 'Bispot申請' },
];

/**
 * データ種別
 */
export enum DataTypeCode {
  bispot = 'bispot',
  btsas = 'btsas',
  cleaning_daily = 'cleaning_daily',
  cleaning_reg = 'cleaning_reg',
  greening_daily = 'greening_daily',
  greening_reg = 'greening_reg',
  request = 'request',
}

/**
 * データ種別（対象ファイル）のキー名
 */
export enum SourceKeys {
  bispot = 'bispot',
  btsas = 'btsas',
  cleaning_daily = 'cleaning_daily',
  cleaning_reg = 'cleaning_reg',
  greening_daily = 'greening_daily',
  greening_reg = 'greening_reg',
  request_all = 'request_all',
  request_cleaning = 'request_cleaning',
  request_greening = 'request_greening',
  request_security = 'request_security',
  request_equipment = 'request_equipment',
}

/**
 * 表示用の対象ファイル（清掃）
 */
export const SourceDisplayForCleaning: ValueLabelPair<SourceKeys>[] = [
  { value: SourceKeys.cleaning_daily, label: '日常清掃' },
  { value: SourceKeys.cleaning_reg, label: '定期清掃 年間計画表（予実表）' },
];

/**
 * 表示用の対象ファイル（植栽）
 */
export const SourceDisplayForGreening: ValueLabelPair<SourceKeys>[] = [
  { value: SourceKeys.greening_daily, label: '常駐管理（植栽）' },
  { value: SourceKeys.greening_reg, label: '定期管理（植栽）' },
];

/**
 * 表示用の対象ファイル（設備）
 */
export const SourceDisplayForEquipment: ValueLabelPair<SourceKeys>[] = [
  { value: SourceKeys.btsas, label: 'BT-SAS 月次予定リスト' },
];

/**
 * 表示用の対象ファイル（臨時）
 */
export const SourceDisplayForRequest: ValueLabelPair<SourceKeys>[] = [
  { value: SourceKeys.request_all, label: '臨時作業（すべて）' },
  { value: SourceKeys.request_cleaning, label: '臨時作業（清掃）' },
  { value: SourceKeys.request_greening, label: '臨時作業（植栽）' },
  { value: SourceKeys.request_equipment, label: '臨時作業（設備）' },
  { value: SourceKeys.request_security, label: '臨時作業（警備）' },
];

/**
 * データ種別名
 */
export const DataTypeNames: { [key: string]: string } = {
  bispot: 'Bispot作業申請情報',
  btsas: 'BT-SAS作業計画・実績',
  cleaning_daily: '日常作業計画(清掃)',
  cleaning_reg: '定期作業計画(清掃)',
  greening_daily: '常駐作業計画(植栽)',
  greening_reg: '定期作業計画(植栽)',
  request: '臨時作業依頼',
};

/**
 * データ投入元コード
 */
export const DataSourceMap: { [key: string]: string } = {
  bispot: 'Bispot',
  btsas: 'BT-SAS',
  report: '日報管理システム',
  kakehashi: '梯',
  mainsys: '本システム',
};

/**
 * 業務データ種別コードのキー名
 */
export enum DataTypeKeys {
  dataTypeBispot = 'bispot',
  dataTypeRequest = 'request',
  dataTypeCleaning = 'cleaning',
  dataTypeEquipment = 'equipment',
  dataTypeGreening = 'greening',
}

/**
 * 業務データ種別コードのキー名
 * @param sourceKey キー
 */
export function sourceKeysToDataType(sourceKey: SourceKeys): DataTypeKeys {
  switch (sourceKey) {
    case SourceKeys.bispot:
      return DataTypeKeys.dataTypeBispot;
    case SourceKeys.cleaning_daily:
    case SourceKeys.cleaning_reg:
      return DataTypeKeys.dataTypeCleaning;
    case SourceKeys.greening_daily:
    case SourceKeys.greening_reg:
      return DataTypeKeys.dataTypeGreening;
    case SourceKeys.btsas:
      return DataTypeKeys.dataTypeEquipment;
    default:
      return DataTypeKeys.dataTypeRequest;
  }
}

/**
 * 業務データ種別コード
 * @param sourceKey キー
 */
export function sourceKeysToBusinessType(sourceKey: SourceKeys): BusinessTypeKeys {
  switch (sourceKey) {
    case SourceKeys.bispot:
      return BusinessTypeKeys.bispot;
    case SourceKeys.cleaning_daily:
    case SourceKeys.request_cleaning:
    case SourceKeys.cleaning_reg:
      return BusinessTypeKeys.cleaning;
    case SourceKeys.request_greening:
    case SourceKeys.greening_daily:
    case SourceKeys.greening_reg:
      return BusinessTypeKeys.greening;
    case SourceKeys.btsas:
    case SourceKeys.request_equipment:
      return BusinessTypeKeys.equipment;
    case SourceKeys.request_security:
      return BusinessTypeKeys.security;
    default:
      return BusinessTypeKeys.none;
  }
}

/**
 * 業務データ種別コード
 * @param dataType キー
 */
export function dataTypeToBusinessType(dataType: DataTypeKeys): BusinessTypeKeys {
  switch (dataType) {
    case DataTypeKeys.dataTypeCleaning:
      return BusinessTypeKeys.cleaning;
    case DataTypeKeys.dataTypeGreening:
      return BusinessTypeKeys.greening;
    case DataTypeKeys.dataTypeEquipment:
      return BusinessTypeKeys.equipment;
    case DataTypeKeys.dataTypeBispot:
      return BusinessTypeKeys.bispot;
    default:
      return BusinessTypeKeys.none;
  }
}

/**
 * 業務データ種別コード
 * @param businessType キー
 */
export function businessTypeToDataType(businessType: BusinessTypeKeys): DataTypeKeys {
  switch (businessType) {
    case BusinessTypeKeys.cleaning:
      return DataTypeKeys.dataTypeCleaning;
    case BusinessTypeKeys.greening:
      return DataTypeKeys.dataTypeGreening;
    case BusinessTypeKeys.equipment:
      return DataTypeKeys.dataTypeEquipment;
    case BusinessTypeKeys.bispot:
      return DataTypeKeys.dataTypeBispot;
    default:
      return DataTypeKeys.dataTypeRequest;
  }
}

/**
 * 業務データ種別コード
 */
export const DataType: KeyValuePair<DataTypeKeys>[] = [
  { key: DataTypeKeys.dataTypeBispot, value: 'Bispot' },
  { key: DataTypeKeys.dataTypeCleaning, value: '清掃' },
  { key: DataTypeKeys.dataTypeEquipment, value: '設備' },
  { key: DataTypeKeys.dataTypeGreening, value: '植栽' },
  { key: DataTypeKeys.dataTypeRequest, value: '臨時' },
];

/**
 * 作業計画参照・更新画面用の業務データ種別コード
 */
export const CsvListDataType: KeyValuePair<DataTypeKeys>[] = [
  { key: DataTypeKeys.dataTypeCleaning, value: '清掃' },
  { key: DataTypeKeys.dataTypeGreening, value: '植栽' },
  { key: DataTypeKeys.dataTypeEquipment, value: '設備' },
  { key: DataTypeKeys.dataTypeRequest, value: '臨時' },
];

/**
 * 部分一致種別のキー名
 */
export enum TextTypeKeys {
  textTypeNone = '0',
  textTypeWork = 'work',
  textTypeTarget = 'target',
}

/**
 * 部分一致種別
 */
export const TextType: KeyValuePair<TextTypeKeys>[] = [
  { key: TextTypeKeys.textTypeWork, value: '作業内容' },
  { key: TextTypeKeys.textTypeTarget, value: '対象箇所' },
];

/**
 * 時間帯
 */
export enum TimeSlot {
  morning = 'morning',
  afternoon = 'afternoon',
  night = 'night',
  all_day = 'all_day',
  none = '',
}

/**
 * 時間帯
 */
export const TimeSlotList: KeyValuePair<TimeSlot>[] = [
  { key: TimeSlot.morning, value: '午前' },
  { key: TimeSlot.afternoon, value: '午後' },
  { key: TimeSlot.night, value: '夜間' },
  { key: TimeSlot.all_day, value: '全日' },
];

/**
 * 対応状況のキー名
 */
export enum ProcessingStatusKeys {
  incomplete = 'incomplete',
  inprogress = 'inprogress',
  completed = 'completed',
  none = 'none',
}

/**
 * 対応状況
 */
export const ProcessingStatus: KeyValuePair<ProcessingStatusKeys>[] = [
  { key: ProcessingStatusKeys.incomplete, value: '未対応' },
  { key: ProcessingStatusKeys.inprogress, value: '対応中' },
  { key: ProcessingStatusKeys.completed, value: '対応終了' },
  { key: ProcessingStatusKeys.none, value: '不明' },
];

/**
 * 表示用の対応状況
 */
export const ProcessingStatusDisplay: KeyValuePair<ProcessingStatusKeys>[] = [
  { key: ProcessingStatusKeys.incomplete, value: '未対応' },
  { key: ProcessingStatusKeys.inprogress, value: '対応中' },
  { key: ProcessingStatusKeys.completed, value: '対応終了' },
];

/**
 * 緊急度のキー名
 */
export enum EmergencyTypeKeys {
  low = 'low',
  medium = 'medium',
  high = 'high',
}

/**
 * 緊急度
 */
export const EmergencyType: KeyValuePair<EmergencyTypeKeys>[] = [
  { key: EmergencyTypeKeys.low, value: '低' },
  { key: EmergencyTypeKeys.medium, value: '中' },
  { key: EmergencyTypeKeys.high, value: '高' },
];

/**
 * 優先度のキー名
 */
export enum PriorityKeys {
  low = 'low',
  medium = 'medium',
  high = 'high',
}

/**
 * 優先度
 */
export const Priority: KeyValuePair<PriorityKeys>[] = [
  { key: PriorityKeys.low, value: '低' },
  { key: PriorityKeys.medium, value: '中' },
  { key: PriorityKeys.high, value: '高' },
];

/**
 * ロボットのserviceTypeのキー名
 */
export enum RobotTypeKeys {
  delivery = 'delivery',
  cleaning = 'cleaning',
  surveillance = 'surveillance',
  reception = 'reception',
  mobility = 'mobility',
  motion = 'motion'
}

/**
 * ロボットのserviceType
 */
export const RobotTypes: KeyValuePair<RobotTypeKeys>[] = [
  { key: RobotTypeKeys.delivery, value: '配送' },
  { key: RobotTypeKeys.cleaning, value: '清掃' },
  { key: RobotTypeKeys.surveillance, value: '監視' },
  { key: RobotTypeKeys.reception, value: '案内' },
  { key: RobotTypeKeys.mobility, value: '移動支援' },
  { key: RobotTypeKeys.motion, value: '地点間移動' }
];

/**
 * ロボットの動作状態
 */
export enum RobotStatus {
  STANDBY = 'STANDBY',
  CHARGING = 'CHARGING',
  NOT_READY = 'NOT_READY',
  OFFLINE = 'OFFLINE',
  IN_OPERATION = 'IN_OPERATION',
  UNKNOWN = 'UNKNOWN'
}

/**
 * ロボット動作状態をもとに、アイコンの表示パターンを返却する
 * @param status
 */
export const getRobotState = (status: string) => {
  switch (status) {
    case RobotStatus.STANDBY:
    case RobotStatus.CHARGING:
      return { isStop: true, isCaution: false };
    case RobotStatus.IN_OPERATION:
      return { isStop: false, isCaution: false };
    case RobotStatus.NOT_READY:
    case RobotStatus.OFFLINE:
    case RobotStatus.UNKNOWN:
    default:
      return { isStop: false, isCaution: true };
  }
};

/**
 * 取得件数
 */
export const Count: KeyValuePair<number>[] = [
  { key: 25, value: '25' },
  { key: 50, value: '50' },
  { key: 100, value: '100' },
];

/**
 * スケジュールの色
 */
export const ScheduleColor = {
  PLAN: '#a3a3ff',
  PLAN_SELECTED: '#8282f5',
};

/**
 * 日付種別のキー名
 */
export enum DateTypeKeys {
  yearly = 'yearly',
  monthly = 'monthly',
}

/**
 * 日付種別
 */
export const DateType: KeyValuePair<DateTypeKeys>[] = [
  { key: DateTypeKeys.yearly, value: '年間' },
  { key: DateTypeKeys.monthly, value: '月次' },
];

/**
 * キーに該当するEnumを返却する
 */
export const getEnumByKey = <T extends Record<string, string>>(enumObj: T, key: string, defaultValue: T[keyof T] = undefined): T[keyof T] => {
  // Enum の値の配列を取得して文字列と一致するものを探す
  const res = Object.values(enumObj).find((enumValue) => enumValue === key);
  if (res === undefined) {
    return defaultValue;
  }
  return res as T[keyof T];
};

/**
 * 作業員のステータス
 */
export enum WorkerStatus {
  WORKING = 'WORKING',
  BREAK = 'BREAK', // 休憩
  EMERGENCY = 'EMERGENCY', // 緊急
}

/**
 * 更新フラグ
 */
export const IssueType = {
  NEW: 'new',
  UPDATE: 'update',
};
